// All the screens
import Homepage from "../Homepage/Homepage";
import About from "../About/About";
import Blog from "../Blog/Blog";
// CSS
import "./App.scss";
// React router for- you guessed it. Routing.
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const App = () => {
	return (
		<main>
			<Router>
				<div>
					<Switch>
						<Route path="/about">
							<About />
						</Route>
						<Route path="/blog">
							<Blog />
						</Route>
						<Route path="/">
							<Homepage />
						</Route>
					</Switch>
				</div>
			</Router>
		</main>
	);
};

export default App;
